import type AttributesObserver from "@ui-utils/AttributesObserver/AttributesObserver";
import type { Observable } from "rxjs";
import { BehaviorSubject, map } from "rxjs";

import type { ProductVariantIdProviderInterface } from "./ProductVariantIdProviderInterface";

export class ProductVariantIdFromAttributeProvider
    implements ProductVariantIdProviderInterface
{
    private readonly variantId$ = new BehaviorSubject<number | null>(null);

    constructor(
        private readonly observer: AttributesObserver,
        private readonly element: HTMLElement,
        private readonly attributeName: string
    ) {
        this.observer
            .observe(this.element, this.attributeName)
            .pipe(map((value) => Number(value) || null))
            .subscribe(this.variantId$);
    }

    selectVariantId(): Observable<number | null> {
        return this.variantId$;
    }
}
